var map = {
	"./NovaComponents-HorizontalBreadcrumb-gui-icu.properties": [
		980,
		"nova_i18n"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_ar.properties": [
		981,
		"nova_i18n_ar"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_cs.properties": [
		982,
		"nova_i18n_cs"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_da.properties": [
		983,
		"nova_i18n_da"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_de.properties": [
		984,
		"nova_i18n_de"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_el.properties": [
		985,
		"nova_i18n_el"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_es.properties": [
		986,
		"nova_i18n_es"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_fi.properties": [
		987,
		"nova_i18n_fi"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_fr.properties": [
		988,
		"nova_i18n_fr"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_he.properties": [
		989,
		"nova_i18n_he"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_hr.properties": [
		990,
		"nova_i18n_hr"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_hu.properties": [
		991,
		"nova_i18n_hu"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_it.properties": [
		992,
		"nova_i18n_it"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_iw.properties": [
		993,
		"nova_i18n_iw"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_ja.properties": [
		994,
		"nova_i18n_ja"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_ko.properties": [
		995,
		"nova_i18n_ko"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_nb.properties": [
		996,
		"nova_i18n_nb"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_nl.properties": [
		997,
		"nova_i18n_nl"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_no.properties": [
		998,
		"nova_i18n_no"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_pl.properties": [
		999,
		"nova_i18n_pl"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_pt.properties": [
		1000,
		"nova_i18n_pt"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_pt_BR.properties": [
		1001,
		"nova_i18n_pt_BR"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_ru.properties": [
		1002,
		"nova_i18n_ru"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_sh.properties": [
		1003,
		"nova_i18n_sh"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_sk.properties": [
		1004,
		"nova_i18n_sk"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_sl.properties": [
		1005,
		"nova_i18n_sl"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_sr.properties": [
		1006,
		"nova_i18n_sr"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_sv.properties": [
		1007,
		"nova_i18n_sv"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_th.properties": [
		1008,
		"nova_i18n_th"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_tr.properties": [
		1009,
		"nova_i18n_tr"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_zh-Hans.properties": [
		1010,
		"nova_i18n_zh-Hans"
	],
	"./NovaComponents-HorizontalBreadcrumb-gui-icu_zh-Hant.properties": [
		1011,
		"nova_i18n_zh-Hant"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1063;
module.exports = webpackAsyncContext;